import i18n from '@/i18n';
import importService from './import.service';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';

export interface ImportState {}

const ImportStore: Module<ImportState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async postPoolStructure(context, { pool_id, file }: { pool_id: number; file: File }) {
         let formData = new FormData();
         formData.append('file', file);
         formData.append('pool_id', `${pool_id}`);

         return await importService.postPoolStructure(formData).then((response) => {
            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'success',
                     message: `${i18n.global.t('services.import_successful')}`,
                  },
               },
               { root: true },
            );
            return response;
         });
      },
      async getCandidatesExample() {
         return await importService.getCandidatesExample();
      },
      async getPlanningExample() {
         return await importService.getPlanningExample();
      },
      async postCandidates(context, { file, pool_ids }: { file: File; pool_ids: number[] }) {
         let formData = new FormData();
         formData.append('file', file);
         formData.append('pool_ids', `${pool_ids}`);

         return await importService.postCandidates(formData).then((response) => {
            context.commit('candidate/addOrUpdateCandidatesInPage', response.data.data, { root: true });
            return response;
         });
      },
      async postPlanning({}, { file, board_id }: { file: File; board_id: number }) {
         let formData = new FormData();
         formData.append('file', file);
         formData.append('board_id', `${board_id}`);
         return await importService
            .postPlanning(formData)
            .then((response) => {
               return response;
            })
            .catch((error) => {
               return Promise.reject(error);
            });
      },
   },
};

export default ImportStore;
